import React, { MouseEventHandler, useCallback } from 'react';
import { useField } from 'react-final-form';

import { AddOutlined } from '@mui/icons-material';
import { ButtonBase } from '@mui/material';

import AddContainerMenuButton from './blocks/Container';

type Props = {
  name: string;
};
export default function ColumnPlaceholder({ name }: Props) {
  const { onChange } = useField(name).input;
  const onClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      onChange(AddContainerMenuButton.defaultColumnBlock());
    },
    [onChange]
  );

  return (
    <ButtonBase
      sx={{
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        height: 48,
        width: '100%',
        bgcolor: 'rgba(0,0,0, 0.05)',
      }}
      onClick={onClick}
    >
      <AddOutlined
        sx={{
          p: 0.12,
          bgcolor: 'brand.blue',
          borderRadius: 24,
          color: 'primary.contrastText',
        }}
        fontSize="small"
      />
    </ButtonBase>
  );
}
